<template>
    <div class="payment-gateway-page-wrapper">
        <div class="d-flex flex-column">
            <draggable :sort="true" v-model="paymentOrderList" @end="(e) => onDragEnd(e)">
                <div class="payment-order-item mb-2" :key="item.code" v-for="item in paymentOrder">
                    {{ item.name }}
                </div>
            </draggable>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { VueDraggable } from 'vue-draggable-plus';

    import { formatResponseError } from '../../../utils/api';
    export default {
        components: {
            draggable: VueDraggable,
        },
        name: 'PaymentGatewayOnlineOrder',
        computed: {
            ...mapGetters('paymentGateway', ['paymentOrder']),
            paymentOrderList: {
                get() {
                    return this.paymentOrder;
                },
                set(value) {
                    this.$store.commit('paymentGateway/gotPaymentOrder', value);
                },
            },
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                try {
                    this.$parent.$emit('busy', true);
                    await this.$store.dispatch('paymentGateway/fetchPaymentOrder');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not fetch payment order' });
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },

            async onDragEnd() {
                try {
                    const values = this.paymentOrderList;
                    await this.$store.dispatch('paymentGateway/setPaymentOrder', {
                        payment_methods: values,
                    });
                } catch (e) {
                    console.log(e);
                    this.errorToast({ text: 'Could not move payment.' });
                }
            },
        },
    };
</script>

<style lang="scss">
    .payment-order-item {
        cursor: grab;
        border-radius: 8px;
        padding: 10px 15px;
        text-align: center;
        width: 250px;
        background: #fff;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    }
</style>
